import React from "react";
import ConnectivitySvg from "../../../../icons/PostYourProperty/propertyRatings/Connectivity";
import NeighbourhoodSvg from "../../../../icons/PostYourProperty/propertyRatings/Neighbourhood";
import SafetySvg from "../../../../icons/PostYourProperty/propertyRatings/SafetySvg";
import LivabilitySvg from "../../../../icons/PostYourProperty/propertyRatings/LivabilitySvg";

interface RatingsProp {
  rating: string;
  title: string;
  icon: React.ReactNode;
}
export const PYPRatingsCard = () => {
  const data: RatingsProp[] = [
    {
      rating: "4.7/5",
      title: "Connectivity",
      icon: <ConnectivitySvg className="w-[70px] h-[70px]" />,
    },
    {
      rating: "4.4/5",
      title: "Neighbourhood",
      icon: <NeighbourhoodSvg className="w-[70px] h-[70px]" />,
    },
    {
      rating: "4.7/5",
      title: "Safety",
      icon: <SafetySvg className="w-[70px] h-[70px]" />,
    },
    {
      rating: "4.7/5",
      title: "Livability",
      icon: <LivabilitySvg className="w-[70px] h-[70px]" />,
    },
  ];
  return (
    <div
      className={`mt-14 lg:mt-10 bg-[#FFF8F5] clip-path-bottomRightPropertyCountCard lg:clip-path-bottomRightPostProperty py-10 px-6  xl:gap-12 grid grid-cols-4`}
    >
      {data?.map((item: RatingsProp, index: any) => (
        <div className="flex flex-col items-center " key={index}>
          {item?.icon}
          <p className="mt-3 font-openSans font-normal text-web-body-lg leading-[22px] text-brand-bgBlack">
            {item?.rating}
          </p>
          <p className="font-openSans mt-0.5 font-normal text-web-body-sm leading-4 text-[#717272]">
            {item?.title}
          </p>
        </div>
      ))}
    </div>
  );
};
